import { render, staticRenderFns } from "./LayoutAuth.vue?vue&type=template&id=c8e32808&scoped=true"
import script from "./LayoutAuth.vue?vue&type=script&lang=js"
export * from "./LayoutAuth.vue?vue&type=script&lang=js"
import style0 from "./LayoutAuth.vue?vue&type=style&index=0&id=c8e32808&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8e32808",
  null
  
)

export default component.exports